import React from 'react';
import { Link } from 'react-router-dom';

// Texte des articles : **gras** et [lien](/chemin) ; les liens internes passent
// par le routeur, les autres s'ouvrent normalement.
const TOKEN = /\*\*(.+?)\*\*|\[(.+?)\]\((.+?)\)/g;

export function rich(text: string): React.ReactNode {
  const out: React.ReactNode[] = [];
  let last = 0;
  for (const m of Array.from(text.matchAll(TOKEN))) {
    const at = m.index ?? 0;
    if (at > last) out.push(text.slice(last, at));
    const key = out.length;
    if (m[1] !== undefined) out.push(<b key={key}>{m[1]}</b>);
    else if (m[3].startsWith('/')) {
      out.push(
        <Link key={key} to={m[3]}>
          {m[2]}
        </Link>,
      );
    } else {
      out.push(
        <a key={key} href={m[3]} target="_blank" rel="noopener noreferrer">
          {m[2]}
        </a>,
      );
    }
    last = at + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out.length === 1 ? out[0] : out;
}

// Texte sans balisage (temps de lecture, données structurées)
export const plain = (text: string) => text.replace(TOKEN, (_, b, label) => b ?? label);
